import React, { useRef, useState } from "react";
import { Button, Form, Input, Modal, message } from "antd";
import { verifyNoteOTPContent } from "../../utils";

const Otp = ({ onSetUi, token }) => {
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [otpValues, setOtpValues] = useState(["", "", "", ""]); // Store OTP values
  const [isError, setIsError] = useState(false); // Track input errors

  const handleInput = (e, index) => {
    const { value } = e.target;

    // Allow only numeric input
    if (/^\d?$/.test(value)) {
      const newValues = [...otpValues];
      newValues[index] = value;
      setOtpValues(newValues);
      setIsError(false); // Reset error on valid input

      // Focus next input
      if (value && index < 3) {
        inputRefs[index + 1].current.focus();
      }
    } else {
    }
  };

  const handleKeyDown = (e, index) => {
    const { value } = e.target;

    if (/^\d?$/.test(value) && !isNaN(value)) {
      const newValues = [...otpValues];
      newValues[index] = value;
      setOtpValues(newValues);
      setIsError(false); // Reset error on valid input

      // Focus next input
      if (value && index < 3) {
        inputRefs[index + 1].current.focus();
      }
    } else {
      setIsError(true);
      inputRefs[index].current.value = ""; // Clear the input value
      inputRefs[index].current.blur();
    }

    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      inputRefs[index - 1].current.focus(); // Move focus to the previous input on backspace
    }
  };

  const handleOTP = async () => {
    // Validate all fields are filled
    if (otpValues.some((val) => val === "")) {
      setIsError(true);
      message.error("Please enter the complete 4-digit code.");
      return;
    }
    // Proceed with verification
    const res = await verifyNoteOTPContent(`/v1/shared-notes/verify`, {
      token,
      otp: otpValues.join(""),
    });
    if (res.status === 200) {
      if (res.data?.data?.content === null) {
        setIsError(true);
        message.error(res.data?.message);
      } else {
        onSetUi("content", res?.data?.data?.content);
      }
    } else {
      onSetUi("expirec");
    }
  };

  /*const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("Text").trim();

    // Ensure pasteData is a 4-digit numeric string
    if (/^\d{4}$/.test(pasteData)) {
      const newValues = pasteData.split("");
      console.log('newValues --->>>> ',newValues);
      setOtpValues(pasteData);

      // Set values for each input and focus the next empty input
      newValues.forEach((value, index) => {
        setTimeout(() => {
          console.log('value - ', value);
          inputRefs[index].current.value = value.trim();
          if (index < 3) {            
              inputRefs[index + 1].current.focus();
            }
          }
        , 10); // small delay to allow iOS to manage focus
      });
      setIsError(false);
    } else {
      setIsError(true);
      message.error("Please paste a valid 4-digit code.");
    }
  };*/
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("Text").trim();
    // Ensure pasteData is a numeric string and matches the length of your OTP input fields
    if (/^\d+$/.test(pasteData) && pasteData.length === inputRefs.length) {
      const newValues = pasteData.split("");
      // Update OTP state
      setOtpValues(newValues);
      // Populate each input field with the corresponding character and move focus to the next input
      newValues.forEach((value, index) => {
        if (inputRefs[index]) {
          inputRefs[index].current.value = value;
        }
      });
      // Focus the next input after the last filled one, if available
      const nextIndex = Math.min(newValues.length, inputRefs.length - 1);
      if (inputRefs[nextIndex]) {
        inputRefs[nextIndex].current.focus();
      }
    }
  };

  return (
    <Modal title={<h1 className="font-bold">Verify Code</h1>} centered open={true} footer={false} closable={false}>
      <p className="font-normal">Enter the 4-digit code sent to open the shared note.</p>
      <p className="font-normal">OTP is valid for only 15 minutes otherwise shared note is expired.</p>
      <Form
        name="otp"
        layout="vertical"
        initialValues={{ remember: true }}
        style={{ marginTop: 24 }}
        autoComplete="off"
      >
        {/* <h1 className="text-sm mb-1 font-medium">
          Code <span className="text-red-500">*</span>
        </h1> */}
        <div className="flex gap-3 justify-center">
          {inputRefs.map((inputRef, index) => (
            <Input
              type="number"
              key={index}
              maxLength={1}
              size="large"
              className={`w-[85px] h-[85px] text-center otp-input ${isError ? "border-red-500" : ""}`}
              ref={inputRef}
              value={otpValues[index]}
              onChange={(e) => handleInput(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
            />
          ))}
        </div>
        <Button className="bg-[#3DAD33] text-white rounded-full w-full h-[45px] mt-10" onClick={handleOTP}>
          Verify
        </Button>
      </Form>
    </Modal>
  );
};

export default Otp;
